export default __webpack_public_path__ + "static/media/user.1a6f80a8.png";